import { makeStyles } from '@mui/styles';

export const useCarouselStyles = makeStyles((theme) => ({
  slider: {
    width: '98%',
    margin: '0 auto',
    position: 'relative',
    marginBottom: '130px',
  },
}));
